import {AppState} from '../reducers';

export const isAdminRoleSelector = (state: AppState) => {
    return state?.userState?.authorities?.includes('ROLE_USER_ADMIN') || false;
};

export const isConsumerSelector = (state: AppState) => {
    return state?.userState?.authorities?.includes('ROLE_CONSUMER') || false;
}
